import { render, staticRenderFns } from "./ForExamResult.vue?vue&type=template&id=cede67a0&scoped=true"
import script from "./ForExamResult.vue?vue&type=script&lang=js"
export * from "./ForExamResult.vue?vue&type=script&lang=js"
import style0 from "./ForExamResult.vue?vue&type=style&index=0&id=cede67a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cede67a0",
  null
  
)

export default component.exports